//@ts-nocheck
//@ts-ignore
/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { useStore } from '../../store/store';
import { MultiCheck } from '../../components/ui/multi-check/MultiCheck';
import { MultiOption } from '../../components/ui/multi-check/Option';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import Button from 'src/onboarding/components/ui/button/Button';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { Text } from 'src/onboarding/components/typography/Text/Text';

function Page() {
  const favoriteFoods = useStore((state) => state.favoriteFoods);
  const setFavoriteFoods = useStore((state) => state.setFavoriteFoods);
  const [next, setNext] = useState(favoriteFoods.length > 0);
  const { onNext, onPrev, currentIndex } = useNav();

  const handleChange = (value) => {
    setFavoriteFoods(value);
    setNext(value.length > 0);
  };

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.favoriteFoods.title')}</Title>
        <Text className='description' size='m' medium>
          {t('onboarding.favoriteFoods.subtitle')}
        </Text>
      </div>

      <div className={'controls'} style={{ marginBottom: 70 }}>
        <MultiCheck defaultValue={favoriteFoods} onChange={handleChange}>
          <MultiOption value={'sweets'}>
            <span>🍫</span> {t('onboarding.favoriteFoods.options.sweets')}
          </MultiOption>
          <MultiOption value={'breadPasta'}>
            <span>🍞</span> {t('onboarding.favoriteFoods.options.breadPasta')}
          </MultiOption>
          <MultiOption value={'cheese'}>
            <span>🧀</span> {t('onboarding.favoriteFoods.options.cheese')}
          </MultiOption>
          <MultiOption value={'fastFood'}>
            <span>🍕</span> {t('onboarding.favoriteFoods.options.fastFood')}
          </MultiOption>
          <MultiOption value={'drinksAlcohol'}>
            <span>🍷</span> {t('onboarding.favoriteFoods.options.drinksAlcohol')}
          </MultiOption>
          <MultiOption value={'meat'}>
            <span>🥩</span> {t('onboarding.favoriteFoods.options.meat')}
          </MultiOption>
          <MultiOption value={'other'}>
            <span>🥑</span> {t('onboarding.favoriteFoods.options.other')}
          </MultiOption>
        </MultiCheck>
        <div className={'overlay'}></div>
      </div>

      <div className={'next-wrapper'}>
        <Button
          className={next ? '' : 'disabled'}
          title={t('onboarding.favoriteFoods.continue')}
          onClick={() => {
            if (!next) return;
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'favorite-foods',
              answer: favoriteFoods.join(', '),
            });
            onNext();
          }}
        />
      </div>
    </div>
  );
}
export default Page;
